import { Button, HistoryModal, PageHeader, ProjectLeaveModal, Table } from "@/components";
import getLocalStorage from "@/hooks/getLocalStorage";
import store from "@/store/store";
import {
  CREATE_TYPE,
  getMessageResponseType,
  handleMessagesAPI,
  HISTORY_TYPE,
  PAGINATION_DEFAULT,
  PROJECT_LEAVE_DETAIL_SCREEN,
  TMS_ROLE_ADMIN,
  TMS_ROLE_HR,
  TMS_ROLE_HRM,
  toFixedNumber,
} from "@/utils";
import { mapState } from "vuex";
const columns = [
  {
    title: "No.",
    dataIndex: "no",
    key: "no",
    scopedSlots: { customRender: "no" },
    width: 60,
    align: "right",
  },
  {
    title: "Project Code",
    dataIndex: "projectCode",
    key: "projectCode",
    customCell() {
      return {
        style: {
          color: "#0379B0",
        },
      };
    },
    width: 180,
  },
  {
    title: "Project Name",
    dataIndex: "projectName",
    key: "project",
    ellipsis: true,
    customCell() {
      return {
        style: {
          color: "#0379B0",
        },
      };
    },
  },
  {
    title: "Apply Date",
    dataIndex: "applyDateFormat",
    key: "applyDate",
    width: 180,
    align: "center",
  },
  {
    title: "Expired Date",
    dataIndex: "expireDateFormat",
    key: "expiredDate",
    width: 180,
    align: "center",
  },
  {
    dataIndex: "leaveDay",
    key: "leaveDay",
    slots: { title: "totalLeaveDay" },
    customRender(value) {
      return toFixedNumber(value, 3);
    },
    width: 150,
    align: "right",
  },
  {
    dataIndex: "used",
    key: "used",
    slots: {
      title: "totalUsed",
    },
    customRender(value) {
      return toFixedNumber(value, 3);
    },
    width: 150,
    align: "right",
  },
  {
    dataIndex: "expired",
    key: "expired",
    slots: {
      title: "totalExpired",
    },
    customRender(value) {
      return toFixedNumber(value, 3);
    },
    width: 150,
    align: "right",
  },
  {
    dataIndex: "remaining",
    key: "remaining",
    slots: {
      title: "totalRemain",
    },
    customRender(value) {
      return toFixedNumber(value, 3);
    },
    width: 150,
    align: "right",
  },
  {
    title: "Attach file",
    dataIndex: "attachFilePaths",
    key: "file",
    customRender(value) {
      if (value?.length > 0) {
        return `Link File`;
      }
      return "";
    },
    customCell(record) {
      return {
        style: {
          cursor: "pointer",
          color: "#0379B0",
        },
        on: {
          async click() {
            if (record?.attachFilePaths?.length > 0) {
              try {
                const res = await store.dispatch("projectLeave/downloadAttachFileProjectLeave", {
                  projectLeaveId: record.id,
                });
                handleMessagesAPI(res?.headers);
              } catch (error) {
                const errorObject = await getMessageResponseType(error);
                handleMessagesAPI(errorObject);
              }
            }
          },
        },
      };
    },
    width: 180,
    align: "center",
  },
  {
    title: "Action",
    dataIndex: "action",
    key: "action",
    scopedSlots: { customRender: "action" },
    width: 180,
    fixed: "right",
    align: "center",
  },
];

const slots = [
  {
    key: "totalLeaveDay",
    title: "Leave Day (s)",
  },
  {
    key: "totalUsed",
    title: "Used",
  },
  {
    key: "totalExpired",
    title: "Expired",
  },
  {
    key: "totalRemain",
    title: "Remaining",
  },
];

const actions = [
  {
    key: "history",
    value: "history",
    title: "History",
  },
  {
    key: "edit",
    value: "edit",
    title: "Edit",
  },
  {
    key: "remove",
    value: "remove",
    title: "Remove",
  },
];

export default {
  name: "ProjectLeaveDetail",
  components: {
    Button,
    PageHeader,
    Table,
    ProjectLeaveModal,
    HistoryModal,
  },
  props: {
    employeeId: {
      type: String,
      required: true,
      default: () => {
        return getLocalStorage("employeeIdActive");
      },
    },
  },
  data() {
    return {
      columns,
      slots: slots,
      report: {
        leaveDay: 10,
        used: 10,
        expired: 10,
        remaining: 10,
      },
      actions,
      visibleModal: false,
      visibleModalHistory: false,
      actionType: null,
      activeRecord: null,
      filter: PAGINATION_DEFAULT,
      PROJECT_LEAVE_DETAIL_SCREEN,
    };
  },
  computed: {
    ...mapState({
      projectLeaveByEmployeeList: (state) => state.projectLeave.projectLeaveByEmployeeList,
      projectLeaveByEmployeeInfo: (state) => state.projectLeave.projectLeaveByEmployeeInfo,
      historyProjectLeaveList: (state) => state.projectLeave.historyProjectLeaveList,
      pages: (state) => state.projectLeave.pages,
      userInfo: (state) => state.user.userInfo,
    }),
    checkShowAction() {
      const {
        userInfo: { roles },
      } = this;
      return roles?.some((role) => [TMS_ROLE_HR, TMS_ROLE_HRM, TMS_ROLE_ADMIN].includes(role));
    },
  },
  created() {
    this.getProjectLeaveByEmployeeList();
    // Get time server
    this.$store.dispatch("application/getTimeServer");
  },
  methods: {
    toFixedNumber,
    async getProjectLeaveByEmployeeList() {
      this.$store.dispatch("user/loadingRequest");
      try {
        await this.$store.dispatch("projectLeave/getProjectLeaveByEmployeeList", {
          employeeId: this.employeeId,
          ...this.filter,
        });
      } catch (error) {
        handleMessagesAPI(error.response.data);
      } finally {
        this.$store.commit("user/RESET_LOADING");
      }
    },
    handleAddProjectLeave() {
      this.visibleModal = true;
      this.actionType = CREATE_TYPE;
    },
    onCancel() {
      this.visibleModal = false;
      this.visibleModalHistory = false;
    },
    handleChangePagination(payload) {
      this.filter = { ...this.filter, ...payload };
    },
    async onAction({ type, data }) {
      this.actionType = type;
      this.activeRecord = data;
      switch (type) {
        case HISTORY_TYPE: {
          try {
            await this.$store.dispatch("projectLeave/historyProjectLeave", { id: data.id });
            this.visibleModalHistory = true;
          } catch (error) {
            handleMessagesAPI(error.response.data);
          }
          break;
        }
        default: {
          this.visibleModal = true;
        }
      }
    },
  },
};
